<div class="container">
    @if (profileData()) {
        <div class="avatar-wrapper" (click)="countForCheat()">
            <img
                class="avatar-image"
                [src]="getAvatarUrl(profileData())"
                alt="avatar"
                (error)="onImageError($event, 'xx-small', 'avatar')"
            />
        </div>
        <div class="info-wrapper">
            <div class="name">{{ profileData().displayName }}</div>
            <div class="id">SHORT ID: {{ profileData().shortID }}</div>
        </div>
    }
</div>
